/**
 * WovenPattern — an abstract interlacing thread motif rendered as an inline SVG.
 * Purely decorative: aria-hidden and focusable=false so assistive tech skips it.
 * Suggests many strands forming one fabric.
 */
export const WovenPattern = ({ className = "", stroke = "#E0A458", opacity = 0.18 }) => {
  return (
    <svg
      className={className}
      aria-hidden="true"
      focusable="false"
      width="100%"
      height="100%"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 240 240"
    >
      <defs>
        <pattern id="melt-weave" width="80" height="80" patternUnits="userSpaceOnUse" patternTransform="rotate(0)">
          {/* Interlacing sine strands, two directions, forming a woven lattice */}
          <path d="M0 20 Q20 0 40 20 T80 20" fill="none" stroke={stroke} strokeWidth="1.2" opacity={opacity} />
          <path d="M0 60 Q20 40 40 60 T80 60" fill="none" stroke={stroke} strokeWidth="1.2" opacity={opacity} />
          <path d="M20 0 Q0 20 20 40 T20 80" fill="none" stroke="#FAF8F5" strokeWidth="1" opacity={opacity * 0.8} />
          <path d="M60 0 Q40 20 60 40 T60 80" fill="none" stroke="#FAF8F5" strokeWidth="1" opacity={opacity * 0.8} />
        </pattern>
      </defs>
      <rect width="240" height="240" fill="url(#melt-weave)" />
    </svg>
  );
};

export default WovenPattern;
